import { Observer } from 'mobx-react-lite';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import { renderRenderable } from '../../utils/components.utils';
import './BaseLabel.scss';
var BaseLabel = function (props) {
    return React.createElement(Observer, { children: function () { return (React.createElement("label", { className: joinClassName('BaseLabel', props.inline && 'inline'), "data-cy": props.dataCy },
            React.createElement("div", { className: "BaseLabelStartSlot" },
                props.children,
                props.required && React.createElement("em", { className: "BaseInputRequiredMarker" }, "* Required"),
                props.optional && React.createElement("em", { className: "BaseInputOptionalMarker" }, "(Optional)")),
            props.endSlot && React.createElement("div", { className: "BaseLabelEndSlot" }, renderRenderable(props.endSlot)))); } });
};
export default BaseLabel;
